import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	groupLabel: {
		id: 'search-page.app-filter-sidebar.group',
		defaultMessage: 'Filter search by app',
		description: 'aria label for the group of product filters',
	},
	allFilterLabel: {
		id: 'search-page.app-filter-sidebar.all',
		defaultMessage: 'All',
		description:
			'Label for button that filters search to all products (e.g. All, Confluence, Jira)',
	},
	noMatchingResultsTooltip: {
		id: 'search-page.app-filter-sidebar.no-matching-results-tooltip',
		defaultMessage: 'No matching results in {product}',
		description: 'Tooltip text shown on a product when there are no matching results',
	},
});
